(ns app.front.ui.dropdown
  (:require [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [reagent.core :as r]))

(defn toggle-button [props content]
  [:button.bg-transparent.border-0.flex.items-center.flex-row.no-underline
   (assoc props :type "button")
   content])

(defn dropdown
  "Calls :on-toggle when its open state changes. Option clicks and Escape close
   the menu and return focus to the toggle unless an action moved focus elsewhere."
  [_ _ & _]
  (r/with-let [*open?                  (r/atom false)
               *ref                    (atom nil)
               *outside-click-listener (atom nil)
               set-open!               (fn [on-toggle open?]
                                         (when (not= @*open? open?)
                                           (reset! *open? open?)
                                           (when on-toggle (on-toggle open?))))
               close!                  (fn [on-toggle restore-focus?]
                                         (when @*open?
                                           (set-open! on-toggle false)
                                           (when (and restore-focus? @*ref)
                                             (let [active-element (.-activeElement js/document)]
                                               (when (or (= active-element (.-body js/document))
                                                         (.contains @*ref active-element))
                                                 (some-> @*ref (.querySelector "button") .focus))))))]
    (r/create-class
      {:component-did-mount
       (fn [this]
         (let [listener (fn [event]
                          (when (and @*ref (not (.contains @*ref (.-target event))))
                            (close! (:on-toggle (r/props this)) false)))]
           (reset! *outside-click-listener listener)
           (.addEventListener js/document "click" listener)))
       :component-will-unmount
       (fn [] (.removeEventListener js/document "click" @*outside-click-listener))
       :reagent-render
       (fn [{:keys [toggle-props options-props align open-icon-description close-icon-description aria-label
                    close-toggle-element on-toggle]
             :as   props}
            toggle-element & children]
         [:div.relative
          (merge
            (dissoc props
                    :toggle-props
                    :options-props
                    :on-toggle
                    :open-icon-description
                    :close-icon-description
                    :close-toggle-element)
            {:ref         #(reset! *ref %)
             ;; Lets callers style the open wrapper, e.g. data-[open=true]:bg-gray-100.
             :data-open   @*open?
             :on-key-down (fn [event]
                            (when-let [on-key-down (:on-key-down props)]
                              (on-key-down event))
                            (when (and @*open? (= "Escape" (.-key event)) (not (.-defaultPrevented event)))
                              (.preventDefault event)
                              (.stopPropagation event)
                              (close! on-toggle true)))})
          [toggle-button
           (r/merge-props {:aria-label (or aria-label
                                           (if @*open? close-icon-description open-icon-description))}
                          (dissoc toggle-props :omit-icon? :button?)
                          (when (:button? toggle-props)
                            {:class "hover:bg-ui-violet-130 hover:text-white text-cloudpermit-purple"})
                          {:aria-expanded @*open?
                           :on-click      #(set-open! on-toggle (not @*open?))})
           [:<>
            (if (and @*open? close-toggle-element)
              close-toggle-element
              toggle-element)
            (when-not (:omit-icon? toggle-props)
              (cc/icon {:style       {:fill        "currentColor"
                                      :transition  "transform 200ms ease-in-out"
                                      :will-change "transform"
                                      :transform   (if @*open? "scaleY(-1)" "scaleY(1)")}
                        :icon        i/chevron-down
                        :description (or (if @*open? close-icon-description open-icon-description) "")
                        :width       "10"}))]]
          ;; Default :style listed first so callers can override via `:options-props`
          ;; (e.g. flip the menu upward when the toggle sits in a sticky bottom bar).
          (into [:div.flex-col.absolute.min-w-full.animation-appear-slide-down.overflow-auto.overscroll-none
                 (r/merge-props {:style {:top "100%" :z-index "9999"}}
                                options-props
                                {:on-click (fn [event]
                                             (when-let [on-click (:on-click options-props)]
                                               (on-click event))
                                             (close! on-toggle true))
                                 :class    (futil/cs
                                             (if @*open? "flex" "hidden")
                                             (str (or align "right") "-0"))})]
                children)])})))
